import React from 'react';
import classNames from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';

import Tooltip from '@material-ui/core/Tooltip';
import SuccessIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Cancel';
import InfoIcon from '@material-ui/icons/Info';

import * as MappingTypes from 'types/Mapping';

interface Props {
  items: MappingTypes.MappingValidationResult[];
}

function Errors({ items }: Props) {
  const classes = useStyles();

  if (!items.length) {
    return (
      <div className={classes.item}>
        <SuccessIcon className={classNames(classes.statusIcon, classes.success)} /> No errors
      </div>
    );
  }

  return (
    <>
      {items.map((item, index) => {
        const { descriptionHtml, longDescriptionHtml } = item;
        return (
          <div className={classes.item} key={`error-${index}`}>
            <ErrorIcon className={classes.statusIcon} color="error" />
            <div dangerouslySetInnerHTML={{ __html: descriptionHtml }} />

            <Tooltip
              arrow
              title={<div dangerouslySetInnerHTML={{ __html: longDescriptionHtml }} />}
            >
              <InfoIcon className={classes.infoIcon} />
            </Tooltip>
          </div>
        );
      })}
    </>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  item: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(0.5),
  },
  statusIcon: {
    marginRight: theme.spacing(),
    maxWidth: 20,
  },
  success: {
    color: theme.palette.success.main,
  },
  infoIcon: {
    marginLeft: theme.spacing(),
    maxWidth: 16,
  },
}));

export default Errors;
